import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./TravelRuleLogin.css";
import { showToast } from "../../CoreDataService";
import { useSelector } from "react-redux";

const TravelRuleOriginatorInfo = ({ data }) => {
  const { brokerDetailedInfo } = useSelector((state) => state);
  const [userTravelData, setUserTravelData] = useState(null);
  const [validName, setValidName] = useState("2");
  const [validAccount, setValidAccount] = useState("2");
  const [validUniqueId, setValidUniqueId] = useState("2");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // First, try to get data from navigation state
    if (location.state && location.state.userTravelData) {
      const receivedData = location.state.userTravelData;
      setUserTravelData(receivedData);
      console.log("Data received from navigation:", receivedData);

      // Also store in localStorage as backup
      localStorage.setItem("userTravelData", JSON.stringify(receivedData));
    }
    // Fallback: try to get from localStorage
    else {
      const storedData = localStorage.getItem("userTravelData");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setUserTravelData(parsedData);
        console.log("Data loaded from localStorage:", parsedData);
      } else {
        // Redirect to login if no data found
        console.log("No data found, redirecting to login");
        navigate("/travel-rule-authentication");
      }
    }
  }, [location, navigate]);

  // Method to save travel rule data
  const saveTravelRuleData = async () => {
    if (!userTravelData) return;

    const payload = {
      validName: validName,
      validAccount: validAccount,
      adminUser: userTravelData.username,
    };

    if (userTravelData.uniqueId !== null) {
      payload.validUniqueId = validUniqueId;
    }

    try {
      const response = await fetch(
        "https://accounts.paybito.com/api/home/storeVerifierResponse",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg); // Error message
      } else {
        showToast("success", result.error.error_msg); // Success message
      }
    } catch (error) {
      console.error("Error saving travel rule data:", error);
      alert("An error occurred while saving. Please try again.");
    }
  };

  // Helper functions to determine what to display
  const isIndividual = userTravelData?.accountType === 1;
  const isCompany = userTravelData?.accountType !== 1;
  const showUniqueIdSection = userTravelData?.uniqueId !== null;
  const showAddress = userTravelData?.uniqueId === "Address";
  const showDOB = userTravelData?.uniqueId === "DOB";
  const showPassport =
    userTravelData?.uniqueId !== "Address" &&
    userTravelData?.uniqueId !== "DOB";

  var frontPagebakgColor =
    "linear-gradient(90deg, " +
    brokerDetailedInfo?.color?.backgroundColor1 +
    " 0%, " +
    brokerDetailedInfo?.color?.backgroundColor2 +
    " 60%)";

  // Dynamic styles
  const bodyStyle = {
    background: frontPagebakgColor,
    minHeight: "100vh",
    margin: "0px !important",
  };

  const navStyle = data?.styleOne
    ? { background: data.backgroundNavColorDynamic, height: "60px" }
    : { backgroundColor: "blue", height: "60px" };

  if (!userTravelData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="bitrump-body paybito-bitrump" style={bodyStyle}>
      {/* Navbar */}

      {/* Main Content */}
      <div className="container">
        <div className="mx-auto mt-5">
          <div className="card-header text-center text-blue p-0"></div>

          <h5
            className="py-3"
            style={{
              textAlign: "center",
              fontSize: "45px",
              paddingTop: "0px !important",
              color: "#fff",
            }}
          >
            Travel Rule Originator Info
          </h5>

          <div
            className="card-body p-3 card-login-body"
            style={{ color: "black", backgroundColor: "white" }}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="my-5">
                  <div className="terms-use-wrap">
                    <div className="p-1">
                      <p>
                        Compliance Requirement: Travel Rule Originator Question:
                        Validation required
                      </p>
                      <p>
                        Your crypto firm has been identified by our user as the
                        originator crypto firm for a transfer made by the user.
                        This transfer is coming from your firm to ours.
                      </p>
                      <p>
                        Please validate the information within 48 hours. The
                        crypto asset received by the user from your
                        exchange/wallet shall be on hold until this information
                        is validated by you. This is a regulatory requirement.
                      </p>
                      <p>
                        The response from the user is as below. You are required
                        to validate this information.
                      </p>
                      <p>
                        <b>User's Responses</b>
                      </p>
                      <p>
                        Originating entity selected by User :{" "}
                        {isIndividual ? "Individual" : "Company"}
                      </p>
                      {/* <p id="userType">
                        
                      </p> */}

                      <div className="outer_list">
                        <p> Name of recipient entity : {userTravelData.name}</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <div className="form-check">
                            <input
                              type="radio"
                              className="travel_radio_btn"
                              name="validName"
                              value="2"
                              checked={validName === "2"}
                              onChange={(e) => setValidName(e.target.value)}
                            />{" "}
                            This info is false
                          </div>

                          <div className="form-check">
                            <input
                              type="radio"
                              className="travel_radio_btn"
                              name="validName"
                              value="1"
                              checked={validName === "1"}
                              onChange={(e) => setValidName(e.target.value)}
                            />{" "}
                            We confirm that this info is true
                          </div>
                        </div>
                      </div>
                      <br />

                      <p>
                        What is the account number or their customer number or
                        unique identifier of the originator in the exchange or
                        wallet you are making the transfer from?
                      </p>
                      <div className="outer_list">
                        <p>Account No :{userTravelData.accountId}</p>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <div className="form-check">
                            <input
                              type="radio"
                              className="travel_radio_btn"
                              name="validAccount"
                              value="2"
                              checked={validAccount === "2"}
                              onChange={(e) => setValidAccount(e.target.value)}
                            />{" "}
                            This info is false
                          </div>

                          <div className="form-check">
                            <input
                              type="radio"
                              className="travel_radio_btn"
                              name="validAccount"
                              value="1"
                              checked={validAccount === "1"}
                              onChange={(e) => setValidAccount(e.target.value)}
                            />{" "}
                            We confirm that this info is true
                          </div>
                        </div>
                      </div>

                      {/* Individual Section */}
                      {isIndividual && (
                        <div className="indiSection">
                          {/* <p>
                            Originator's address or passport or national ID
                            number or date and place of birth as registered on
                            the originating exchange or wallet.
                          </p>
                          <p>
                            The user provided (show the one the user provided)
                          </p>
                          <p>
                            Originator's address / Originator's Passport or
                            national ID number / Originator's Date of birth and
                            place of birth [city and country]
                          </p> */}

                          {showAddress && (
                            <>
                              <p className="address">Originator's address</p>
                              <p id="address" className="uniqueId address">
                                {userTravelData.address}
                              </p>
                            </>
                          )}

                          {showPassport && (
                            <>
                              <p className="passport">
                                Originator's Passport or national ID number
                              </p>

                              <p id="passport" className="uniqueId passport">
                                {userTravelData.passport}
                              </p>
                            </>
                          )}

                          {showDOB && (
                            <>
                              <p className="birth">
                                Originator's Date of birth and place of birth
                                [city and country]
                              </p>
                              <p id="birth" className="uniqueId birth">
                                {userTravelData.dob}
                              </p>
                            </>
                          )}
                          {showUniqueIdSection && (
                            <p> Unique Id :{userTravelData.uniqueId}</p>
                          )}
                          <div className="outer_list">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                              }}
                            >
                              <div className="form-check">
                                <input
                                  type="radio"
                                  className="travel_radio_btn"
                                  name="validUniqueId"
                                  value="2"
                                  checked={validUniqueId === "2"}
                                  onChange={(e) =>
                                    setValidUniqueId(e.target.value)
                                  }
                                />{" "}
                                This info is false
                              </div>

                              <div className="form-check">
                                <input
                                  type="radio"
                                  className="travel_radio_btn"
                                  name="validUniqueId"
                                  value="1"
                                  checked={validUniqueId === "1"}
                                  onChange={(e) =>
                                    setValidUniqueId(e.target.value)
                                  }
                                />{" "}
                                We confirm that this info is true
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Enterprise Section */}
                      {isCompany && (
                        <div className="entrSection">
                          <p>
                            Please provide the originator Company identification
                            number or the Principal place of business as
                            registered on the originating exchange or wallet.
                          </p>
                          <p>
                            The user provided (show the one the user provided)
                          </p>
                          <p>
                            Company identification number / Principal place of
                            business of the originator enterprise
                          </p>
                          <p id="idnumber" className="mb-0 pb-0 uniqueId">
                            {userTravelData.companyId}
                          </p>

                          <div className="outer_list">
                            <div className="form-check">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="radio"
                                  className="travel_radio_btn"
                                  name="validUniqueIdCompany"
                                  value="2"
                                  checked={validUniqueId === "2"}
                                  onChange={(e) =>
                                    setValidUniqueId(e.target.value)
                                  }
                                />{" "}
                                This info is false
                              </div>

                              <div className="form-check">
                                <input
                                  type="radio"
                                  className="travel_radio_btn"
                                  name="validUniqueIdCompany"
                                  value="1"
                                  checked={validUniqueId === "1"}
                                  onChange={(e) =>
                                    setValidUniqueId(e.target.value)
                                  }
                                />{" "}
                                We confirm that this info is true
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="outer_list mb-3">
                        <button
                          style={{ width: "20%" }}
                          className="btn btn-primary mt-3"
                          id="submitBtn"
                          onClick={saveTravelRuleData}
                        >
                          Submit
                        </button>
                      </div>

                      {/* <p>Thank you for validating the information.</p>
                      <p>Sincerely,</p>
                      <p>{data?.exchange || "Exchange"}</p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelRuleOriginatorInfo;
